import { openSection } from 'assets/themes/campings/js/page/product/navigation'

export default (): void => {
  const target = 'reviews'
  if (!document.querySelector<HTMLElement>(`[data-target="${target}"]`)) {
    return
  }

  openSection(target)
}
